import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ShareFileDialogData {
  message: string;
}

export interface ShareFileDialogResult {
  confirmed: boolean;
  dontShowAgain: boolean;
}

@Component({
  selector: 'app-share-file-dialog',
  templateUrl: './share-file-dialog.component.html',
  styleUrls: ['./share-file-dialog.component.scss']
})
export class ShareFileDialogComponent implements OnInit {
  message = "";
  dontShowAgainChecked: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ShareFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareFileDialogData
  ) { }

  ngOnInit() {
    if (this.data?.message) {
      this.message = this.data.message;
    }
  }

  onYesClick() {
    const result: ShareFileDialogResult = {
      confirmed: true,
      dontShowAgain: this.dontShowAgainChecked
    };

    this.dialogRef.close(result);
  }

  onNoClick() {
    const result: ShareFileDialogResult = {
      confirmed: false,
      dontShowAgain: this.dontShowAgainChecked
    };

    this.dialogRef.close(result);
  }
}
